// src/Views/Art.js
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import ScrambleText from '../Components/ScrambleText';
import './Art.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";

import Amma from '../assets/images/Amma.jpeg';
import NissanGTR from '../assets/images/NissanGTR.jpeg';
import MainCharacter from '../assets/images/MainCharacter.jpeg';
import TigerCub from '../assets/images/TigerCub.jpeg'
import PavitrPrabakar from '../assets/images/PavitrPrabakar.jpeg'
import Appa from '../assets/images/Appa.jpeg'
import shraddha from '../assets/images/shraddha.jpeg'
import Me from '../assets/images/Me.jpeg'

const artworks = [
  {
    name: 'Amma ✨',
    medium: 'Oil paint on canvas',
    description: "Amma is a portrait of my mother, capturing her warmth and wisdom through vibrant colors and expressive brushstrokes. Never has she taken a 'No' for an answer. Nothing and no one can stand in the way of her success. She has so much Aura.",
    image: Amma,
  },
    {
    name: 'Appa ✨',
    medium: 'Pencil shading on paper',
    description: 'If there is a person who can raise 2 kids, start 3 software companies and still keep his sanity, it is my dad. His ability to keep calm and make the best decisions in the worst situations is uncanny. I could not ask for a better father.',
    image: Appa,
  },
    {
    name: 'Shraddha ✨',
    medium: 'Acrylic on canvas',
    description: "She's way too naughty. She's also the most street smart person I know. She promised me she'd get extremely rich and give me all her money so I can live an extremely luxurious life. Trust.",
    image: shraddha,
  },
    {
    name: 'Me ✨',
    medium: 'Pencil shading on paper',
    description: "Note to self: be unique, push boundaries, make your own reality. Don't think outside the box. Redefine the box itself. Also stay the goofball you are.",
    image: Me,
  },
  {
    name: 'Vroom Vroom 🤣',
    medium: 'Oil paint on canvas',
    description: 'The NissanGTR be so iconic. What’s better than owning one? Painting one. My dream car is better than your dream car. Just take the L.',
    image: NissanGTR,
  },
  {
    name: 'Bro Thinks He\'s The Main Character',
    medium: 'Acrylic on canvas',
    description: 'I don’t know if bro’s taking off or landing. My art teacher and I had a whole argument about it. I like to believe he is taking off. Everyone is the main character in their story. What’s the use of a main character if they get everything right in the first attempt? So try new things and mess up as many times as you want.',
    image: MainCharacter,
  },
  {
    name: 'TigerCub',
    medium: 'Acrylic on canvas',
    description: 'The cub looks so bold. Almost like it is ready to take on the world. Sometimes, all you need is a little bit of courage to take the first step. The rest will follow.',
    image: TigerCub,
  },
  {
    name: 'Pavitr Prabakar 💓',
    medium: 'Watercolor on Paper',
    description: 'Spider-Man: Across the Spider-Verse was a masterpiece. The animation was top-notch. Their depiction of India was next level. I hope I can animate and produce work of that quality someday. This artwork is a depiction of my favourite character from the movie.',
    image: PavitrPrabakar,
  },
];

function Art() {
  const location = useLocation();
  const [selectedArt, setSelectedArt] = useState(null);
  const [showCardNudge, setShowCardNudge] = useState(false);

  useEffect(() => {
    const hasSeenNudge = window.sessionStorage.getItem('art-card-nudge-seen');
    if (hasSeenNudge) return undefined;

    setShowCardNudge(true);
    const timer = window.setTimeout(() => {
      setShowCardNudge(false);
      window.sessionStorage.setItem('art-card-nudge-seen', 'true');
    }, 4200);

    return () => window.clearTimeout(timer);
  }, []);

  const openArtwork = (art) => {
    setShowCardNudge(false);
    window.sessionStorage.setItem('art-card-nudge-seen', 'true');
    setSelectedArt(art);
  };

  useEffect(() => {
    if (!selectedArt) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [selectedArt]);

  useEffect(() => {
    const targetIndex = location.state?.fromHomeCard
      ? location.state.openItem
      : null;
    if (!Number.isInteger(targetIndex) || !artworks[targetIndex]) return undefined;

    const timer = window.setTimeout(
      () => setSelectedArt(artworks[targetIndex]),
      360
    );
    return () => window.clearTimeout(timer);
  }, [location.state]);

  return (
    <main className="art-page">
      <section className="art-hero">
        {/* <p className="art-eyebrow">Gallery</p> */}
        <h1><ScrambleText text="Art" /></h1>
        <p className="art-intro">
          A collection of selected works across different mediums, surfaces,
          and sizes. Select an artwork to see it in full size and read its story.
        </p>
      </section>

      <section className="art-grid">
        {artworks.map((art, index) => (
          <article
            className={`art-card ${index === 0 && showCardNudge ? 'art-card--nudging' : ''}`}
            key={index}
            onClick={() => openArtwork(art)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openArtwork(art);
              }
            }}
          >
            <div className="art-image-wrap">
              <img
                src={art.image}
                alt={art.name}
                className="art-image"
                loading="lazy"
                decoding="async"
              />

            <button
              className="art-expand-button"
              aria-label={`View ${art.name} at full size`}
              onClick={(e) => {
                e.stopPropagation();
                openArtwork(art);
              }}
            >
              <FontAwesomeIcon className="art-expand-icon" icon={faUpRightAndDownLeftFromCenter} />
            </button>
            </div>

            <div className="art-info">
              <h2><ScrambleText text={art.name} /></h2>
              <p className="art-medium">{art.medium}</p>
              {/* <p className="art-size">{art.size}</p> */}
              <p className="art-description">{art.description}</p>
            </div>
          </article>
        ))}
      </section>

      {selectedArt && createPortal(
        <div className="art-modal" onClick={() => setSelectedArt(null)}>
          <div className="art-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="art-modal-close"
              onClick={() => setSelectedArt(null)}
              aria-label="Close popup"
            >
              ×
            </button>

            <div className="art-modal-image-wrap">
              <img
                src={selectedArt.image}
                alt={selectedArt.name}
                className="art-modal-image"
                decoding="async"
              />
            </div>

            <div className="art-modal-info">
              {/* <p className="art-modal-eyebrow">Selected work</p> */}
              <h2><ScrambleText text={selectedArt.name} /></h2>
              <p><strong>Medium:</strong> {selectedArt.medium}</p>
              {/*<p><strong>Size:</strong> {selectedArt.size}</p> */}
              <p>{selectedArt.description}</p>
            </div>
          </div>
        </div>,
        document.body
      )}
    </main>
  );
}

export default Art;
